/* eslint-disable @typescript-eslint/no-empty-function */
import {PopupContainer} from "@FRAMEWORK/ui/mobile/popup";
import {TextButton} from "@FRAMEWORK/ui/mobile/button";
import styled from "@yb/styled-px2rem";
import {OverlayState} from "@/hooks/common/useOverlay";
import {useEffect, useId} from "react";

const AlertWrap = styled.div`
	display: flex;
	flex-direction: column;
	p {
		color: #222;
		text-align: center;
		em {
			color: #ff5c46;
		}
	}
`;

const BlockButton = styled.div`
	display: flex;
	margin: 30px auto 0;
	button {
		+ button {
			margin-left: 10px;
		}
	}
`;

export interface AlertProps {
	/** @description 보여질 문자열 markup */
	text: string;

	/** @description 알림 타입 기본값 : alert */
	alertType?: "alert" | "confirm";

	/** @description 취소나 X 버튼 누를시 실행할 함수 */
	afterClose?: (props?: any) => void;

	/** @description 확인 버튼 누를시 실행할 함수 */
	afterConfirm?: (props?: any) => void;

	/**
	 * @description  (value: boolean | PromiseLike<boolean>) => void
	 */
	resolve?: (value: boolean | PromiseLike<boolean>) => void;
}

const Alert = (props: OverlayState & AlertProps) => {
	const {close, text, afterClose, afterConfirm, alertType = "alert", resolve, ...overlayProps} = props;
	const id = useId();

	const onClose = () => {
		close();
		typeof resolve === "function" && resolve(false);
		setTimeout(() => {
			typeof afterClose === "function" && afterClose();
		}, 300);
	};

	const onConfirm = () => {
		close();
		typeof resolve === "function" && resolve(true);
		setTimeout(() => {
			typeof afterConfirm === "function" && afterConfirm();
		}, 300);
	};

	useEffect(() => {
		setTimeout(() => {
			(document.querySelector(`#${CSS.escape(id)}`) as HTMLButtonElement)?.focus();
		}, 300);
	}, []);

	return (
		<>
			<PopupContainer {...overlayProps} title="안내" size="basic" close={onClose}>
				<AlertWrap>
					<p dangerouslySetInnerHTML={{__html: text}}></p>
				</AlertWrap>
				<BlockButton>
					{alertType === "confirm" && (
						<TextButton text="취소" types="basic" size="default" width="basic" onClick={onClose} />
					)}
					<TextButton text="확인" types="confirm" size="default" width="basic" onClick={onConfirm} id={id} />
				</BlockButton>
			</PopupContainer>
		</>
	);
};

export default Alert;
